module.exports = __webpack_public_path__ + "h5/img/mfe_03.3bd9c112.jpeg";